import { createSelector } from "@ngrx/store";
import { storeSelector } from "@core/store/store.selector";

export const currentUser = createSelector(
  storeSelector,
  store => store?.user
);

export const isDeveloper = createSelector(
  currentUser,
  user => user?.is_developer
);

export const selectUsers = createSelector(
  storeSelector,
  store => store.users
);
